import PageContainer from '../../layouts/PageContainer/PageContainer'
import * as styles from './FeedbackForm.module.scss'

function FeedbackForm({ url }) {
  return (
    <PageContainer title="Feedback">
      <div className={styles.feedbackFormContainer}>
        <iframe
          className={styles.feedbackForm}
          title="feedback"
          src={url}
          width="640"
          height="1200"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0">
          Loading…
        </iframe>
      </div>
    </PageContainer>
  )
}

export default FeedbackForm
